let scrollTop = 1
export default {
  scrollTop,
}
